import {
  GET_APPLICATIONS,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_FAILURE,
  CHANGE_APP_STATUS,
  CHANGE_APP_STATUS_SUCCESS,
  CHANGE_APP_STATUS_FAILURE,
  GET_APPLICATION_DETAILS,
  GET_APPLICATION_DETAILS_SUCCESS,
  GET_APPLICATION_DETAILS_FAILURE,
  REQ_LOR,
  REQ_LOR_SUCCESS,
  REQ_LOR_FAILURE,
} from "../constants";

const initialState = {
  applications: [],
  acceptedApplicationsCount: 0,
  rejectedApplicationsCount: 0,
  waitlistedApplicationsCount: 0,
  pendingApplicationsCount: 0,
  count: 0,
  applicationData: [],
  isLoading: false,
  isApplicationLoading: false,
  error: null,
};

export default function ApplicationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_APPLICATIONS:
    case CHANGE_APP_STATUS:
    case REQ_LOR:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case GET_APPLICATION_DETAILS:
      state = {
        ...state,
        isApplicationLoading: true,
        error: null,
      };
      break;

    case GET_APPLICATIONS_SUCCESS:
      state = {
        ...state,
        applications: action?.payload?.applications,
        acceptedApplicationsCount: action?.payload?.acceptedApplications,
        rejectedApplicationsCount: action?.payload?.rejectedApplications,
        waitlistedApplicationsCount: action?.payload?.waitlistedApplications,
        pendingApplicationsCount: action?.payload?.pendingApplications,
        count: action?.payload?.count,
        isLoading: false,
      };
      break;
    case GET_APPLICATION_DETAILS_SUCCESS:
      state = {
        ...state,
        applicationData: action?.payload,
        isApplicationLoading: false,
      };
      break;
    case CHANGE_APP_STATUS_SUCCESS:
    case REQ_LOR_SUCCESS:
      state = {
        ...state,
        isLoading: false,
      };
      break;

    case GET_APPLICATIONS_FAILURE:
    case CHANGE_APP_STATUS_FAILURE:
    case REQ_LOR_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    case GET_APPLICATION_DETAILS_FAILURE:
      state = {
        ...state,
        isApplicationLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
